// libraries
import React from "react";

// components
import { UxSearch } from "/react4xp/components/Svg/Ux";

// types
export interface SearchFormProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  error?: string;
  totalResults?: number | string; // Can be number or HTML string (e.g., "4 treff på <span>test</span>, <span>test 2</span>")
  searchTerm?: string;
  placeholder?: string;
  name?: string;
}

export default function SearchForm({
  value,
  onChange,
  onSubmit,
  error,
  totalResults,
  searchTerm,
  placeholder,
  name,
}: SearchFormProps) {
  return (
    <>
      <form action="#" className="search-page__form" onSubmit={onSubmit}>
        <button aria-label="Søk" type="submit" className="search-page__button">
          <UxSearch />
        </button>

        <input
          type="text"
          placeholder={placeholder || "Søk"}
          name={name || "s"}
          className="search-page__input"
          value={value || ""}
          onChange={onChange}
          aria-label={placeholder || "Søk"}
        />
      </form>

      {error && <div className="search-page__error">{error}</div>}

      {totalResults !== undefined &&
        totalResults !== null &&
        (typeof totalResults === "string" ? (
          <div
            className="search-page__results-count"
            dangerouslySetInnerHTML={{ __html: totalResults }}
            suppressHydrationWarning
          />
        ) : (
          searchTerm && (
            <div className="search-page__results-count">
              <span className="search-page__results-number">
                {totalResults} treff på{" "}
              </span>
              <span className="search-page__results-term">{searchTerm}</span>
            </div>
          )
        ))}
    </>
  );
}

